const addScript = (script = {}) => {

  try {
    if (!script.src) throw new Error('!!! ERROR (addScript) Unable to add script to DOM.  No source URL provided.')

    script = Object.assign(
      document.createElement('script'), {
        async: true,
        crossOrigin: 'anonymous',
        onload: () => MK.events.emit('DOM:add:element:script', script),
        type: 'text/javascript'
      }, script
    )

    MK.DOM.elements.head.appendChild(script)
  } catch (error) {
    console.log(error)
    MK.captureException && MK.captureException(error)
  }
}


export {
  addScript
}